import ManagerStatistics from "../components/Statistics/ManagerStatistic";
import CustomerStatistics from "../components/Statistics/CustomerStatistic";
import {PERM} from "../utilites/permissions";

const statistics = [
  {
    path: '/statistics/manager',
    name: 'ManagerStatistics',
    component: ManagerStatistics,
    meta: {requiresAuth: true,
      permissions: [
        PERM.STATISTIC,
      ]
    },
  },
  {
    path: '/statistics/customer',
    name: 'CustomerStatistics',
    component: CustomerStatistics,
    meta: {requiresAuth: true,
      permissions: [
        PERM.STATISTIC,
      ]
    },
  },
];

export default statistics;



// WEBPACK FOOTER //
// ./src/router/statistics.js